import { Link } from "react-router-dom";

function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50">
      <h1 className="text-3xl font-bold text-slate-900">Page not found</h1>
      <Link
        to="/"
        className="text-blue-600 underline"
        onClick={() => sessionStorage.removeItem("obd_instance_id")}
      >
        Go home
      </Link>
    </div>
  );
}

export default NotFoundPage;
